<template>
    <div
        class="md-cta-multiple-column three-column-color-bg"
        :class="{
            'mg-container': !fullColumn
        }"
        :style="{ marginBottom }"
    >
        <div
            ref="content"
            class="content"
            :style="{ minHeight: minHeight + 'px' }"
        >
            <site-card
                customClass="left-card card"
                :class="leftBgType === 'color' ? 'no-opacity' : ''"
                :title="leftTitle"
                :description="leftDesc"
                :buttonStyle="{
                    color: leftButtonBorderColor,
                    borderColor: leftButtonBorderColor
                }"
                :buttonText="leftButtonText"
                :action="buttonAction1"
                :siteImgOptions="leftSiteImgOptions"
                :layerStyle="leftLayerStyle"
            ></site-card>
            <site-card
                customClass="middle-card card"
                :class="middleBgType === 'color' ? 'no-opacity' : ''"
                :title="middleTitle"
                :description="middleDesc"
                :buttonStyle="{
                    color: middleButtonBorderColor,
                    borderColor: middleButtonBorderColor
                }"
                :buttonText="middleButtonText"
                :action="buttonAction2"
                :siteImgOptions="middleSiteImgOptions"
                :layerStyle="middleLayerStyle"
            ></site-card>
            <site-card
                customClass="right-card card"
                :class="rightBgType === 'color' ? 'no-opacity' : ''"
                :title="rightTitle"
                :description="rightDesc"
                :buttonStyle="{
                    color: rightButtonBorderColor,
                    borderColor: rightButtonBorderColor
                }"
                :buttonText="rightButtonText"
                :action="buttonAction3"
                :siteImgOptions="rightSiteImgOptions"
                :layerStyle="rightLayerStyle"
            ></site-card>
        </div>
    </div>
</template>

<script>
import SiteCard from '../_components/site-card.vue';
import common from '../index';

export default {
    mixins: [common],
    components: {
        SiteCard
    },
    data: function() {
        let config = {
            topSpacing: false,
            btmSpacing: false,
            fullColumn: true
        };
        let blockConfig = {
            minHeight: '',
            blockSizeOption: {
                type: 'height',
                mobileType: 'height',
                height: 524,
                mobileHeight: 1446,
                mobileRatio: 378
            }
        };
        let leftColumnConfig = {
            leftTitle: '',
            leftDesc: '',
            leftButtonText: '',
            leftButtonAction: {
                type: 'url',
                href: '/',
                target: '_blank'
            },
            leftButtonBgColor: '',
            leftButtonBorderColor: '',
            leftLayerDisplay: true,
            leftLayerColor: '',
            leftBgType: 'color',
            leftImgOptions: {},
            leftBgColor: 'rgba(255,255,255,1)'
        };
        let middleColumnConfig = {
            middleTitle: '',
            middleDesc: '',
            middleButtonText: '',
            middleButtonAction: {
                type: 'url',
                href: '/',
                target: '_blank'
            },
            middleButtonBgColor: '',
            middleButtonBorderColor: '',
            middleLayerDisplay: true,
            middleLayerColor: '',
            middleBgType: 'color',
            middleImgOptions: {},
            middleBgColor: ''
        };
        let rightColumnConfig = {
            rightTitle: '',
            rightDesc: '',
            rightButtonText: '',
            rightButtonAction: {
                type: 'url',
                href: '/',
                target: '_blank'
            },
            rightButtonBgColor: '',
            rightButtonBorderColor: '',
            rightLayerDisplay: true,
            rightLayerColor: '',
            rightBgType: 'color',
            rightImgOptions: {},
            rightBgColor: 'rgba(255,255,255,1)'
        };
        return {
            ...config,
            ...blockConfig,
            ...leftColumnConfig,
            ...middleColumnConfig,
            ...rightColumnConfig
        };
    },
    computed: {
        buttonAction1() {
            let action = this.leftButtonAction;
            //  When the click button is selected to pop up the registration box mode ， Just pass the callback function
            return action.type === 'callback'
                ? {
                    type: 'callback',
                    callback: this.showRegisterPop.bind(this, action)
                }
                : action;
        },
        buttonAction2() {
            let action = this.middleButtonAction;
            return action.type === 'callback'
                ? {
                    type: 'callback',
                    callback: this.showRegisterPop.bind(this, action)
                }
                : action;
        },
        buttonAction3() {
            let action = this.rightButtonAction;
            return action.type === 'callback'
                ? {
                    type: 'callback',
                    callback: this.showRegisterPop.bind(this, action)
                }
                : action;
        },
        leftBgImg() {
            if (!this.isMobile) {
                return (
                    this.leftImgOptions.src ||
                    this.leftImgOptions.mobileSrc ||
                    ''
                );
            } else {
                return (
                    this.leftImgOptions.mobileSrc ||
                    this.leftImgOptions.src ||
                    ''
                );
            }
        },
        middleBgImg() {
            if (!this.isMobile) {
                return (
                    this.middleImgOptions.src ||
                    this.middleImgOptions.mobileSrc ||
                    ''
                );
            } else {
                return (
                    this.middleImgOptions.mobileSrc ||
                    this.middleImgOptions.src ||
                    ''
                );
            }
        },
        rightBgImg() {
            if (!this.isMobile) {
                return (
                    this.rightImgOptions.src ||
                    this.rightImgOptions.mobileSrc ||
                    ''
                );
            } else {
                return (
                    this.rightImgOptions.mobileSrc ||
                    this.rightImgOptions.src ||
                    ''
                );
            }
        },
        leftSiteImgOptions() {
            return this.leftBgType === 'img'
                ? {
                    type: 'bgImg',
                    src: this.leftBgImg
                }
                : {
                    type: 'bgColor',
                    src: '',
                    bgColor: this.leftBgColor
                };
        },
        middleSiteImgOptions() {
            return this.middleBgType === 'img'
                ? {
                    type: 'bgImg',
                    src: this.middleBgImg
                }
                : {
                    type: 'bgColor',
                    src: '',
                    bgColor: this.middleBgColor
                };
        },
        rightSiteImgOptions() {
            return this.rightBgType === 'img'
                ? {
                    type: 'bgImg',
                    src: this.rightBgImg
                }
                : {
                    type: 'bgColor',
                    src: '',
                    bgColor: this.rightBgColor
                };
        },
        leftLayerStyle() {
            //  If the mask is not shown ， Just set the background color transparency to 0
            return this.leftLayerDisplay
                ? {
                    backgroundColor: this.leftLayerColor,
                    minHeight: this.cardHeight
                }
                : {
                    backgroundColor: 'rgba(255,255,255,0)',
                    minHeight: this.cardHeight
                };
        },
        middleLayerStyle() {
            //  If the mask is not shown ， Just set the background color transparency to 0
            return this.middleLayerDisplay
                ? {
                    backgroundColor: this.middleLayerColor,
                    minHeight: this.cardHeight
                }
                : {
                    backgroundColor: 'rgba(255,255,255,0)',
                    minHeight: this.cardHeight
                };
        },
        rightLayerStyle() {
            //  If the mask is not shown ， Just set the background color transparency to 0
            return this.rightLayerDisplay
                ? {
                    backgroundColor: this.rightLayerColor,
                    minHeight: this.cardHeight
                }
                : {
                    backgroundColor: 'rgba(255,255,255,0)',
                    minHeight: this.cardHeight
                };
        },
        cardHeight() {
            // 60*2*3 is mobile card gap
            return this.isMobile
                ? (this.minHeight - 60 * 2 * 3) / 3 + 'px'
                : this.minHeight - 120 + 'px';
        }
    }
};
</script>

<style lang="scss">
@import '@/theme/media.scss';
@import '@/theme/mixin.scss';
.md-cta-multiple-column.three-column-color-bg {
    .content {
        display: flex;
        justify-content: center;
        position: relative;
        .card {
            flex: 1;
            z-index: 1; //  be taller than the black mask layer
            position: relative;
            display: flex;
            align-items: center;
            .site-card {
                width: 100%;
                margin: 60px;
                padding: 40px 30px;
                display: flex;
                flex-direction: column;
                .title {
                    text-align: center;
                    font-size: 32px;
                    font-family: var(--font-bold);
                    columns: #000000;
                    @include webkitBox(3);
                }
                .description {
                    text-align: center;
                    margin-top: 20px;
                    font-size: 16px;
                    line-height: 1.5;
                    color: #797e8b;
                    overflow: hidden;
                    flex: 1;
                }
                .button {
                    margin-top: 40px;
                    font-size: 16px;
                    font-family: var(--font-bold);
                    padding: 10px;
                    border: solid 2px #202437;
                    background-color: transparent;
                    @include ellipsis();
                    text-align: center;
                    cursor: pointer;
                    &:hover {
                        background-color: rgba(0, 0, 0, 0.1);
                    }
                }
            }
            &.no-opacity {
                &:after {
                    display: none; //  when background is color   remove black mask
                }
            }
        }
        @include media-600 {
            flex-direction: column;
            .card {
                .site-card {
                    margin: 20px;
                    padding: 40px 20px;
                }
            }
        }
    }
}
</style>
